import React, { Dispatch, SetStateAction, useState } from 'react';
import errorImage from '../../assets/images/error-ok.svg';
import Button from '../../components/atoms/Button/Button';
import styles from './Error.module.scss';
import SupportButton from '../../components/atoms/SupportButton/SupportButton';
import Container from '../../components/atoms/Container/Container';
import NewMethodBlock from '../../components/organisms/NewMethodBlock/NewMethodBlock';

interface Props {
  onOk?: () => void;
  onRetry?: () => void;
  transaction?: any;
  onCancel?: () => void;
  setRetry?: Dispatch<SetStateAction<number>>;
  retry?: number;
  uuid?: string;
  transgranError?: boolean;
  setTransgranError: Dispatch<SetStateAction<boolean>>;
  setLoading?: Dispatch<SetStateAction<boolean>>;
}

const Error: React.FC<Props> = ({
  onOk,
  onRetry,
  setRetry,
  onCancel,
  retry,
  transaction,
  uuid,
  transgranError,
  setTransgranError,
  setLoading,
}) => {
  const [showTransgran, setShowTransgran] = useState<boolean>(true);
  const retryHandler = () => {
    if (typeof setRetry === 'function') {
      setRetry((prev) => prev + 1);
    }
  };

  return transgranError ? (
    <>
      <section className={styles.wrapper}>
        <div style={{ marginBottom: '28px' }}>
          {transaction?.merchant?.toLowerCase() === 'vocxod' && (
            <SupportButton userId={transaction.externalUserId} />
          )}
        </div>
        <div className={styles.container}>
          <img src={errorImage} alt='server error' />

          {transgranError && (
            <p className={styles.text}>
              К сожалению не удалось обработать Ваш запрос
            </p>
          )}

          {transaction?.redirectUrl && (
            <div className={styles.btnWrapper}>
              <Button onClick={onOk} dataSentryElement='error-ok'>
                Ок
              </Button>
            </div>
          )}
        </div>
      </section>
    </>
  ) : (
    <section className={styles.wrapper}>
      <div style={{ marginBottom: '28px' }}>
        {transaction?.merchant?.toLowerCase() === 'vocxod' && (
          <SupportButton userId={transaction.externalUserId} />
        )}
      </div>
      <div className={styles.container}>
        <img src={errorImage} alt='server error' />
        {onRetry && !transgranError && (
          <p className={styles.text}>
            Транзакция недоступна, попробуйте еще раз
          </p>
        )}
        {onOk && !transgranError && (
          <p className={styles.text}>Ошибка в загрузке страницы</p>
        )}
        {onCancel && <p className={styles.text}>Не удалось найти реквизит</p>}
        {setRetry ? (
          <>
            <div className={styles.btnWrapper}>
              <Button onClick={retryHandler} dataSentryElement='error-retry'>
                Повторить попытку
              </Button>
            </div>
            <div className={styles.btnWrapper}>
              <Button
                variant='secondary'
                onClick={() => {
                  if (transaction) {
                    window.location.replace(transaction.redirectUrl);
                  }
                }}
                dataSentryElement='error-cancel'
              >
                Отмена
              </Button>
            </div>
          </>
        ) : (
          transaction?.redirectUrl && (
            <div className={styles.btnWrapper}>
              <Button onClick={onOk} dataSentryElement='error-back'>
                Назад
              </Button>
            </div>
          )
        )}
      </div>
      {transaction?.recreationPaymentMethods.length > 0 &&
      uuid &&
      showTransgran ? (
        // <Container className={styles.methodBlockWrapper}>
        //   <NewMethodBlock
        //     transaction={transaction}
        //     uuid={uuid}
        //     setShowTransgran={setShowTransgran}
        //     setTransgranError={setTransgranError}
        //     setLoading={setLoading}
        //   />
        // </Container>
          <></>
      ) : (
        <></>
      )}
    </section>
  );
};

export default Error;
